module.exports = __webpack_public_path__ + "img/cuo.2c62f917.svg";